/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { AddressFieldDisplay } from "./display";
import { AddressFieldEdit } from "./edit";

const AddressField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <AddressFieldDisplay />,
        editComponent: <AddressFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
AddressField.displayName = "AddressField";
export { AddressField };
